module.exports = __webpack_public_path__ + "static/media/androidMock.949e83a0.webp";